import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import "./SubTaskSelect.css";
// import { ISubTask } from "../../../../../models/TaskModels/ISubTask";

import AddedCheck from "../../../../../assets/ButtonIcons/subtask-control-added.svg";
import RemoveCross from "../../../../../assets/ButtonIcons/subtask-control-remove.svg";
import AddPlus from "../../../../../assets/ButtonIcons/subtask-control-add.svg";
import Search from "../../../../UiLib/Search/Search";
import { Context } from "../../../../../index";
import SelectDropdown from "../../../../Shared/SelectDropdown/SelectDropdown";
import { AppContext } from "../../../../../App";
import { TaskContext } from "../../../../../contexts/TaskContext";
import { handleError } from "../../../../../helpers/ErrorLib/handleError";
import { ISubTask } from "../../../../../common/api_interfaces/task/ISubTask";

const SubTaskSelect = () => {
    const { store } = useContext(Context);
    const taskContext = useContext(TaskContext);
    const { showToast, handleShowLoader } = useContext(AppContext);

    const [searchValue, setSearchValue] = useState<string>("");
    const [hoveredSubtask, setHoveredSubtask] = useState<number | undefined>(undefined);
    const [selectedProjectId, setSelectedProjectId] = useState<number | undefined>(
        taskContext.taskInformation?.projectId
    );

    useEffect(() => {
    }, [taskContext.subTasks])

    const handleSubTaskControlClick = useCallback(async (taskId: number) => {
        const task = taskContext.subTasks?.find((xx) => xx.id === taskId);
        if (!task) return;

        try {
            handleShowLoader(true);
            await store.taskService.setTaskParent({
                taskId: task.id,
                parentTaskId: task.parentId ? undefined : taskContext.taskInformation?.id,
            });
            await taskContext.loadSubTasks();
        } catch (error) {
            handleError(error, {
                defaultMessage: "Неизвестная ошибка при добавлении подзадачи",
                showToast: showToast
            });
        } finally {
            handleShowLoader(false);
        }
    }, [
        taskContext.subTasks, 
        store.taskService, 
        taskContext.taskInformation?.id, 
        taskContext.loadSubTasks, 
        showToast
    ]);

    const handleSearchSubmit = useCallback((value: string | undefined) => {
        setSearchValue(value ?? "");
    }, []);

    const filteredSubtasks = useMemo(() => {
        if (!taskContext.subTasks) return [];

        return taskContext.subTasks.filter((task) => {
            const isNotCurrentTask = task.id !== taskContext.taskInformation?.id;
            const isSelectedProject = task.projectId === selectedProjectId;
            const matchesSearch = searchValue === "" || 
                task.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
                task.number?.toLowerCase().includes(searchValue.toLowerCase());
            
            return isNotCurrentTask && isSelectedProject && matchesSearch;
        });
    }, [
        taskContext.subTasks, 
        taskContext?.taskInformation?.id, 
        selectedProjectId, 
        searchValue
    ]);

    const ProjectSelect = useMemo(() => {
        const selectedProject = taskContext.allowedProjects?.find(p => p.id === selectedProjectId);
        
        if (!taskContext.allowedProjects?.length) return null;

        return (
            <div className="subtask-project-dropdown">
                <SelectDropdown>
                    <SelectDropdown.Selected>
                        <div>{selectedProject?.name ?? ""}</div>
                    </SelectDropdown.Selected>
                    {taskContext.allowedProjects.map(p => (
                        <SelectDropdown.Option key={p.id}>
                            <div 
                                className="subtask-project-option" 
                                onClick={() => setSelectedProjectId(p.id)}
                            >
                                {p.name}
                            </div>
                        </SelectDropdown.Option>
                    ))}
                </SelectDropdown>
            </div>
        );
    }, [taskContext.allowedProjects, selectedProjectId]);

    const SubTaskItemControl = useCallback((subTask: ISubTask) => {
        const handleMouseEvents = () => {
            setHoveredSubtask(subTask.id);
        };

        const handleMouseLeave = () => {
            setHoveredSubtask(undefined);
        };

        const controlProps = {
            onClick: () => handleSubTaskControlClick(subTask.id),
            onMouseOver: handleMouseEvents,
            onMouseOut: handleMouseLeave,
            style: { marginLeft: "auto" },
            className: "subtask-control-base row-align"
        };

        if (hoveredSubtask === subTask.id && subTask.parentId) {
            return (
                <div {...controlProps} className={`${controlProps.className} remove-control`}>
                    <img src={RemoveCross} alt="Remove" />
                    <div style={{ marginLeft: "auto" }}>Удалить</div>
                </div>
            );
        }

        if (!subTask.parentId) {
            return (
                <div {...controlProps} className={`${controlProps.className} add-control`}>
                    <img src={AddPlus} alt="Add" />
                    <div style={{ marginLeft: "auto" }}>Добавить</div>
                </div>
            );
        }

        return (
            <div {...controlProps} className={`${controlProps.className} added-control`}>
                <img src={AddedCheck} alt="Added" />
                <div style={{ marginLeft: "auto" }}>Добавлена</div>
            </div>
        );
    }, [hoveredSubtask, handleSubTaskControlClick]);

    return (
        <div className="right-menu-subtask-select-container">
            <div className="right-menu-subtask-select-controls row-align">
                {ProjectSelect}
                <Search
                    value={searchValue}
                    changeSearchValue={handleSearchSubmit}
                    onSubmitFunc={handleSearchSubmit}
                />
            </div>
            <div className="right-menu-subtask-select-items-container column-align">
                {filteredSubtasks.map((subTask: ISubTask) => (
                    <div
                        key={`subtask_${subTask.id}_s`}
                        className="subtask-select-item row-align"
                    >
                        <div className="subtask-select-item-info">
                            <div
                                style={{ color: "var(--secondary-text-gray)" }}
                                className="p_14"
                            >
                                {subTask.number}
                            </div>
                            <div
                                style={{ fontWeight: "600" }}
                                className="p_18 subtask-select-item-info-name"
                            >
                                {subTask.name}
                            </div>
                        </div>
                        {SubTaskItemControl(subTask)}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SubTaskSelect;